import ReviewManagementTemplate from "../../../templates/admin/reviewManagement";

const ReviewManagementScreen = () => {
  return <ReviewManagementTemplate />;
};

export default ReviewManagementScreen;
